import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { commonStrings } from "../../../../../globalization";
import { AdmPanelContainer } from "../../../../adm-panel/site/api/screens";
import { ProductUpdateScreenFactoryImpl } from "./components";
import { ProductControllerImpl } from "../../../business";

export function ProductUpdate() {
  const cs = commonStrings().PTBR.dashboard.auto_part.create;
  const { state } = useLocation();
  const [productData, setProductData] = useState();
  const [isLoading, setLoading] = useState(true);
  const controller = new ProductControllerImpl();
  const factory = new ProductUpdateScreenFactoryImpl();

  const fetchData = async () => {
    try {
      const response = await controller.productRequest(
        `products-adm/${state.productId}`
      );
      setLoading(false);
      setProductData(response);
    } catch (error) {
      console.error("Erro na requisição:", error);
      setLoading(false);
      setProductData([]);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const content = (
    <>
      <h4 className="mb-4">{cs.title}</h4>
      {isLoading ? <p>Carregando...</p> : factory.create(productData)}
    </>
  );
  return <AdmPanelContainer children={content} />;
}
